exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mission[data-v-f657b1f4] {\n  text-align: center;\n  min-height: 60vh;\n  background: white;\n  margin-left: 0;\n  margin-right: 0;\n  font-size: 18px;\n  overflow: hidden;\n  background: url(\"/static/img/geres-cat-cris-ola.jpg\") no-repeat;\n  background-attachment: fixed;\n  background-size: cover;\n  color: white;\n  text-shadow: 2px 2px 5px black;\n  min-height: calc(100vh - 200px);\n  margin-bottom: -150px;\n}\nh1[data-v-f657b1f4] {\n  padding-top: 10vh;\n  margin-bottom: 50px;\n}\nh4[data-v-f657b1f4] {\n  max-width: 30em;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 50px;\n  line-height: 1.5;\n}\n.actions[data-v-f657b1f4] {\n  margin-top: 70px;\n  margin-bottom: 200px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f657b1f4","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home/Mission.vue
// module id = 678
// module chunks = 3